












import { mapGetters, mapState } from 'vuex';
import FeatureFlagRedirectMixin from '@/mixins/copy-stake/FeatureFlagRedirectMixin';
import { ECopyStakeFeatureFlag } from '@/store/modules/feature-flags/FeatureFlagNames';

const CopyStakeAutoclickerTabsView = (): Promise<any> =>
  import(
    '@/views/CopyStake/CopyStakeAutoclicker/CopyStakeAutoclickerTabsView.vue'
  );

export default {
  name: 'CopyStakeAutoclickerView',
  components: {
    CopyStakeAutoclickerTabsView
  },
  mixins: [FeatureFlagRedirectMixin],
  computed: {
    ...mapState('app', ['isSuperAdmin']),
    ...mapGetters('FeatureFlags', [
      'isEnabledFeatureFlag',
      'isAdminVisibleFeatureFlag'
    ]),
    isFeatureVisible(): boolean {
      const handler = this.isSuperAdmin
        ? this.isEnabledFeatureFlag
        : this.isAdminVisibleFeatureFlag;

      return handler(ECopyStakeFeatureFlag.COPYSTAKE_AUTOCLICKER);
    }
  }
};
